export function getFileExtension(url: string) {
	const urlAfterLastSlash = url.split('/').pop()!
	return urlAfterLastSlash.slice(((urlAfterLastSlash.lastIndexOf('.') - 1) >>> 0) + 2)
}
